import React, { memo, useMemo, useReducer, useState } from 'react';
import {
  AdvanceFilter,
  Button,
  Modal,
  Table,
  Text,
} from 'components/src';
import {
  routesName,
  useDeleteAdminDeleteAccess,
  useGetAuthorityAccessList,
  useGetAuthorityFindRoles,
  useNavigation,
} from 'core';
import { useTranslation } from 'react-i18next';
import { Flex, Space, TablePaginationConfig } from 'antd';
import { FilterOutlined, PlusOutlined } from '@ant-design/icons';
import { RiDeleteBin6Line, RiFileExcel2Line } from 'react-icons/ri';
import { CiEdit } from 'react-icons/ci';
import { PiNotebookLight } from 'react-icons/pi';
import {
  handleModal,
  initialState,
  setId,
  updateCurrentPage,
  reducer,
} from './store';

interface Props {}

const OperationalAccessList = memo<Props>(() => {
  const { _navigate, _navigateWithParams } = useNavigation();
  const { i18n } = useTranslation();
  const [{ currentPage, showModal, id }, dispatch] = useReducer(
    reducer,
    initialState
  );

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>(
    []
  );
  const { data: { data } = {}, refetch } = useGetAuthorityAccessList({
    pageNumber: currentPage,
    pageSize: '10',
  });

  const { mutate } = useDeleteAdminDeleteAccess({
    onSuccess: () => {
      refetch();
    },
  });
  const columns: any = [
    {
      title: i18n.t('id'),
      key: 'id',
      dataIndex: 'id',
      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('firstEntity'),
      dataIndex: 'entity1',
      key: 'entity1',
      render: (record: any) => <Text>{record}</Text>,

      // <Text>
      //   {record?.user1?.user_name ?? record?.role1?.name}
      // </Text>
    },
    //  {
    //   title: i18n.t("firstEntity"),
    //   dataIndex: "user1",
    //   key: "user1",
    //   render: (text: any) => (
    //     <Text>
    //       {text?text.user_name:""}
    //     </Text>
    //   ),
    // },

    {
      title: i18n.t('secondEntity'),
      dataIndex: 'entity2',
      key: 'entity2',
      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('access'),
      dataIndex: 'authorities',
      key: 'authorities',
      render: (text: any) =>
        text?.map((item: any) => {
          return <Text>{item.name}-</Text>;
        }),
    },
    {
      title: i18n.t('operation'),
      key: 'operation',
      dataIndex: 'operation',
      render: (_: any, record: any) => (
        <Flex align="center" justify="start">
          <Space>
            {/* <Button
              title={i18n.t("details")}
              color="warning"
              onClick={() => {
                _navigateWithParams(routesName.OPRATIONALACCESSDETAIL, {
                  id: record.id,
                });
              }}
            >
              <PiNotebookLight size={20} />
            </Button> */}
            {/* <Button
              title={i18n.t("edit")}
              onClick={() => {
                _navigateWithParams(routesName.EDITOPRATIONALACCESS, {
                  id: record.id,
                });
              }}
            >
              <CiEdit size={20} />
            </Button> */}
            <Button
              title={i18n.t('delete')}
              customColor="danger"
              onClick={() => {
                dispatch(handleModal(true));
                dispatch(setId(record.id));
              }}
            >
              <RiDeleteBin6Line size={20} />
            </Button>
          </Space>
        </Flex>
      ),
    },
  ];

  const onAdvanceFilterChange = (_filterValues: any) => {
    // dispatch(handleFiltering(filterValues));
  };

  const handlePageChange = (current_page: number) => {
    dispatch(updateCurrentPage(current_page));
  };

  const pagination: TablePaginationConfig = {
    current: data?.meta?.current_page,
    pageSize: 10,
    total: data?.totalCount,
    onChange: handlePageChange,
    showSizeChanger: false,
    position: ['bottomRight'],
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const _data = useMemo((): any[] => {
    return data?.access?.map((item: any) => {
      return {
        ...item,
        entity1:
          item?.user1?.user_name ??
          item?.role1?.name ??
          item?.category1?.name,
        entity2:
          item?.user2?.user_name ??
          item?.role2?.name ??
          item?.category2?.name,
      };
    });
  }, [data]);

  return (
    <>
      <Modal
        text={i18n.t('AreYouSureYouWantToDelete')}
        id={id}
        open={showModal}
        onOk={() => {
          mutate({
            queryParams: {
              accessId: id,
            },
          });
          dispatch(handleModal(false));
        }}
        onCancel={() => dispatch(handleModal(false))}
      />
      <Button
        type="primary"
        onClick={() => {
          _navigate(routesName.CREATEOPERATIONALACCESS);
        }}
      >
        <PlusOutlined />
        {i18n.t('create')}
      </Button>
      <Table
        rowSelection={rowSelection}
        // filterComponent={
        //   <AdvanceFilter
        //     setAdvanceFilter={onAdvanceFilterChange}
        //     nameField={true}
        //     activeField={true}
        //     creatorField={true}
        //     serverField={true}
        //   />
        // }
        // loading={isFetching}
        // excelIcon={
        //   <Button
        //     title={i18n.t('downloadCampaigns')}
        //     isLoading={isCampaignNumberStatisticLoading}
        //     onClick={handleDownload}
        //   >
        //     <RiFileExcel2Line
        //       size={25}
        //       color={colors.green01}
        //       onClick={handleDownload}
        //       title={i18n.t('stats')}
        //     />
        //   </Button>
        // }
        {...{ columns }}
        dataSource={_data || []}
        pagination={pagination}
      ></Table>
    </>
  );
});
export { OperationalAccessList };
